import { AbstractBlock } from 'starting-blocks'

import SwiperCore, { Navigation, Pagination } from 'swiper/core'
SwiperCore.use([Navigation, Pagination])

export default class SliderBlock extends AbstractBlock {
  constructor(container) {
    super(container, 'SliderBlock')
    this.swiperEl = null
  }

  init() {
    super.init()
    this.swiperEl = this.rootElement.querySelector('.js-slider')
    this.initSlider()
  }

  initSlider = () => {
    const swiper = new SwiperCore(this.swiperEl, {
      loop: true,
      pagination: {
        el: this.rootElement.querySelector('.swiper-pagination'),
      },
      navigation: {
        nextEl: this.rootElement.querySelector('.swiper-button-next'),
        prevEl: this.rootElement.querySelector('.swiper-button-prev'),
      },
    })
  }

  initEvents() {
    super.initEvents()
    // register events like "click", "input"..
  }

  destroy() {
    super.destroy()
    // only needed when using page transitions
  }

  destroyEvents() {
    super.destroyEvents()
    // only needed when using page transitions
  }

  onResize() {
    super.onResize()
    // this is debounced by default
  }

  onPageReady() {
    super.onPageReady()
  }
}
